import React from "react";

const TrainingManuals = props => (
  <svg viewBox="0 0 24 28" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M22.972 4.175v21.657c0 .645-.523 1.168-1.168 1.168H2.168A1.168 1.168 0 011 25.832V2.168C1 1.523 1.523 1 2.168 1h17.263l3.54 3.175z"
        stroke="currentColor"
        strokeWidth={1.099}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        stroke="currentColor"
        strokeWidth={1.099}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.493 5.211V1.55l3.296 2.564z"
      />
      <text
        fill="currentColor"
        fontFamily="Avenir-Book, Avenir"
        fontSize={4.394}
        transform="translate(1 1)"
      >
        <tspan x={7.732} y={19.135}>
          {`Pdf`}
        </tspan>
      </text>
      <path
        d="M6.31 7.958h11.352M6.31 10.338h11.352M6.31 12.901h11.352"
        stroke="currentColor"
        strokeWidth={1.099}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default TrainingManuals;
